import 'rxjs/add/operator/map';
import { MdDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
/* Importing local components/modules starts */
import { Enum } from '../../utility/enum.enum';
import { AppMessage } from './../../Common/appMessage';
import { AppGlobals } from './../../Common/Services/app.global';
import { SharedService } from './../../Common/Services/shared.service';
import { DialogConfirmComponentComponent } from './../../Components/dialog-confirm-component/dialog-confirm-component.component';
import { Menu } from '../../utility/menu';
import { examTypeOptions } from "../../Common/appConstant";
/* Importing local components/modules ends */
var Utility = (function () {
    function Utility(_appGlobals, _sharedService, _dialog, _appMessage, _router) {
        this._appGlobals = _appGlobals;
        this._sharedService = _sharedService;
        this._dialog = _dialog;
        this._appMessage = _appMessage;
        this._router = _router;
        this.leftMenusList = Menu.leftMenusList;
        this.leftMenusList_CUser = null;
        this.days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']; // Sequence of days which we are using everywhere (see Location Setting)
        this.listSubject = new Subject();
        this.txnSubject = new Subject();
        this.loaderSubject = new Subject();
        this.readyForMasterSubject = new Subject();
        this.userLoggedInSubject = new Subject();
        this.loaderCount = 0;
        this.notificationSubject = new Subject();
        this.notificationCount = 0;
        this.readyForMaster = false;
        this.isUserLoggedIn = false;
        this.selectedCountry = "";
        this.authenticateUserRoute = "AuthenticateUser";
        this.toggle_my_Class = 'inactive'; //hide-show notification dropdown for candidate
        this.showGradientBandAtTop = false;
        // Sequence of days with its Id as used everywhere (see Operational hours)
        this.weekdays = [
            { name: "Sunday", Id: 1 },
            { name: "Monday", Id: 2 },
            { name: "Tuesday", Id: 3 },
            { name: "Wednesday", Id: 4 },
            { name: "Thursday", Id: 5 },
            { name: "Friday", Id: 6 },
            { name: "Saturday", Id: 7 }
        ];
        this.valuesPolyfill = function values(object) {
            return Object.keys(object).map(function (key) { return object[key]; });
        };
        this.objValues = Object.values || this.valuesPolyfill; // Object.values does not work in IE browser so use function for that.
    }
    Utility.prototype.clearList = function () {
        this.listSubject.next([]);
    };
    Utility.prototype.getList = function () {
        return this.listSubject.asObservable();
    };
    Utility.prototype.setTxnStatus = function (newVal) {
        this.txnSubject.next(newVal);
    };
    Utility.prototype.clearTxnStatus = function () {
        this.txnSubject.next(false);
    };
    Utility.prototype.getTxnStatus = function () {
        return this.txnSubject.asObservable();
    };
    Utility.prototype.getLoaderStatus = function () {
        return this.loaderSubject.asObservable();
    };
    Utility.prototype.addLoaderCount = function () {
        this.loaderCount++;
        this.loaderSubject.next({ lCount: this.loaderCount });
    };
    Utility.prototype.removeLoaderCount = function () {
        if (this.loaderCount > 0) {
            this.loaderCount--;
        }
        this.loaderSubject.next({ lCount: this.loaderCount });
    };
    Utility.prototype.clearLoaderCount = function () {
        this.loaderCount = 0;
        this.loaderSubject.next(this.loaderCount);
    };
    Utility.prototype.getNotificationStatus = function () {
        return this.notificationSubject.asObservable();
    };
    Utility.prototype.addNotificationCount = function () {
        this.notificationCount++;
        this.notificationSubject.next({ nCount: this.notificationCount });
    };
    Utility.prototype.removeNotificationCount = function () {
        if (this.notificationCount > 0) {
            this.notificationCount--;
        }
        this.notificationSubject.next({ nCount: this.notificationCount });
    };
    Utility.prototype.clearNotificationCount = function () {
        this.notificationCount = 0;
        this.notificationSubject.next({ nCount: this.notificationCount });
    };
    Utility.prototype.setNotificationCount = function (nCounts) {
        if (nCounts >= 0) {
            this.notificationCount = nCounts;
            this.notificationSubject.next({ nCount: this.notificationCount });
        }
    };
    Utility.prototype.getReadyForMasterStatus = function () {
        return this.readyForMasterSubject.asObservable();
    };
    Utility.prototype.setReadyForMasterStatus = function (newStatus) {
        if (newStatus === void 0) { newStatus = false; }
        this.readyForMaster = newStatus;
        this.loaderSubject.next(this.readyForMaster);
    };
    Utility.prototype.getUserLoggedInStatus = function () {
        return this.userLoggedInSubject.asObservable();
    };
    Utility.prototype.setUserLoggedInStatus = function (newStatus) {
        if (newStatus === void 0) { newStatus = false; }
        this.isUserLoggedIn = newStatus;
        this.userLoggedInSubject.next(this.isUserLoggedIn);
    };
    Utility.prototype.getAccessTokenInLS = function () {
        return this.getFromLStorage('individualexamschedulerAccessToken', 'str');
    };
    Utility.prototype.setAccessTokenInLS = function (token) {
        if (token && token != null && token != "") {
            this.setInLStorage('individualexamschedulerAccessToken', 'str', token);
        }
    };
    Utility.prototype.setInLStorage = function (key, valueType, value) {
        var valToSet;
        if (valueType == "obj") {
            valToSet = JSON.stringify(value);
        }
        else {
            valToSet = value;
        }
        localStorage.setItem(key, valToSet);
        return true;
    };
    Utility.prototype.getFromLStorage = function (key, valueType) {
        var retVal;
        retVal = localStorage.getItem(key);
        if (retVal == null) {
            return retVal;
        }
        if (valueType == "obj") {
            retVal = JSON.parse(retVal);
        }
        return retVal;
    };
    Utility.prototype.removeFromLStorage = function (key) {
        localStorage.removeItem(key);
    };
    /**
     *  to convert date/time/date-time in string format [yyyy-MM-dd]
     * @param dateVal type: Date
     * @param type type:string ('d' for date only, 't' for time only, 'dt' for date-time)
     */
    Utility.prototype.convertToDateStr = function (dateVal, type) {
        if (type === void 0) { type = 'dt'; }
        var retStr = null;
        try {
            var dateStr = dateVal.getFullYear()
                + "-" + ((dateVal.getMonth() + 1) >= 10 ? (dateVal.getMonth() + 1) : '0' + (dateVal.getMonth() + 1))
                + "-" + (dateVal.getDate() >= 10 ? dateVal.getDate() : '0' + dateVal.getDate());
            var timeStr = dateVal.getHours() >= 10 ? dateVal.getHours() : ('0' + dateVal.getHours());
            timeStr += ":" + (dateVal.getMinutes() >= 10 ? dateVal.getMinutes().toString() : ('0' + dateVal.getMinutes().toString()));
            timeStr += ":" + (dateVal.getSeconds() >= 10 ? dateVal.getSeconds().toString() : ('0' + dateVal.getSeconds().toString()));
            if (type == 'd') {
                retStr = dateStr;
            }
            else if (type == 't') {
                retStr = timeStr;
            }
            else {
                retStr = dateStr + ' ' + timeStr;
            }
        }
        catch (Error) {
        }
        return retStr;
    };
    // to convert datetime string in system datetime
    Utility.prototype.convertToDateTime = function (dateStr) {
        var retDate = new Date();
        try {
            var tempList = dateStr.split(' ');
            var datePart = tempList.length > 0 ? tempList[0] : null;
            var timePart = tempList.length > 1 ? tempList[1] : null;
            if (datePart != null) {
                datePart = datePart.split('-');
                retDate = new Date(datePart[0].toString(), datePart[1] - 1, datePart[2].toString());
                if (timePart != null) {
                    timePart = timePart.split(':');
                    retDate = new Date(datePart[0], datePart[1] - 1, datePart[2], timePart.length >= 1 ? timePart[0] : 0, timePart.length >= 2 ? timePart[1] : 0, timePart.length >= 3 ? timePart[2] : 0);
                }
            }
        }
        catch (Error) {
            retDate = new Date();
        }
        return retDate;
    };
    // to show long string in dotted format in html
    Utility.prototype.getShortStr = function (str, maxLength) {
        if (str === void 0) { str = ''; }
        var retStr = str;
        if (retStr != null && retStr != '') {
            if (str.length > maxLength) {
                retStr = str.substr(0, maxLength - 3) + '...';
            }
        }
        return retStr;
    };
    //convert case of string that can be used in html as toUpperCase() can not be directly used in html
    Utility.prototype.convertToCase = function (str, newCase) {
        if (str === void 0) { str = ''; }
        if (newCase === void 0) { newCase = 'l'; }
        var retVal = str;
        if (retVal != null && retVal != '') {
            if (newCase == 'u') {
                retVal = retVal.toUpperCase();
            }
            else {
                retVal = retVal.toLowerCase();
            }
        }
        return retVal;
    };
    Utility.prototype.daysUntil = function (date) {
        var days = Math.round((new Date(date).getTime() - new Date().getTime()) / (24 * 60 * 60 * 1000));
        return days > 0 ? days : 0;
    };
    // Call this method to add two durations
    // format:  hh:mm:ss
    Utility.prototype.addDuration = function (firstDuration, secondDuration, ssShow) {
        if (ssShow === void 0) { ssShow = false; }
        if (!firstDuration || !secondDuration) {
            return '';
        }
        ;
        var times = [];
        var times1 = firstDuration.split(':');
        var times2 = secondDuration.split(':');
        for (var i = 0; i < 3; i++) {
            times1[i] = (isNaN(parseInt(times1[i]))) ? 0 : parseInt(times1[i]);
            times2[i] = (isNaN(parseInt(times2[i]))) ? 0 : parseInt(times2[i]);
            times[i] = times1[i] + times2[i];
        }
        var seconds = times[2];
        var minutes = times[1];
        var hours = times[0];
        if ((seconds / 60) >= 1) {
            minutes += Math.floor(seconds / 60);
            seconds = Math.floor(seconds % 60);
        }
        if ((minutes / 60) >= 1) {
            hours += Math.floor(minutes / 60);
            minutes = Math.floor(minutes % 60);
        }
        // hours = (hours.toString().length == 1) ? '0' + hours : hours;
        // minutes = (minutes.toString().length == 1) ? '0' + minutes : minutes;
        //  seconds = (seconds.toString().length == 1) ? '0' + seconds : seconds;
        // if (ssShow) {
        //     return hours + ':' + minutes + ':' + seconds;
        // }
        // else {
        //     return hours + ':' + minutes;
        // }
        var retVal = hours + ':' + minutes;
        //alert(retVal);
        return retVal;
    };
    // Disable Enable Form fields
    Utility.prototype.disableEnableForm = function (form, disable) {
        if (form) {
            disable ? form.disable() : form.enable();
        }
    };
    /**
 * Fetch record based on Id
 * @param model  - autocomplete or combo Field name prefix like region, country, state...
 * @param id - get record of this id param
 */
    Utility.prototype.getRecordById = function (model, id) {
        var data = this._sharedService[model + "List"];
        if (model && data && data.length > 0) {
            var item = data.filter(function (item) { if (item.id == id)
                return item; });
            return item[0];
        }
    };
    /**
     *
     * @param data - data on which we have to filter
     * @param name - value which you have typed in autocomplete field
     */
    Utility.prototype.filterItems = function (data, name) {
        // check whether locationAddress property does exist or not, if yes then compare with both name & locationAddress
        if (data && data.length > 0 && data[0].name && data[0].locationAddress) {
            return data.filter(function (item) {
                // if (item.name.toString().toLowerCase().startsWith(name.toString().toLowerCase()) ||
                //     (item.locationAddress && item.locationAddress.toString().toLowerCase().startsWith(name.toString().toLowerCase()))) {
                if (item.name.toString().toLowerCase().indexOf(name.toString().toLowerCase()) > -1 ||
                    (item.locationAddress && item.locationAddress.toString().toLowerCase().indexOf(name.toString().toLowerCase())) > -1) {
                    return item;
                }
            });
        }
        else if (data && data.length > 0 && data[0].name) {
            return data.filter(function (item) {
                // new RegExp(`^${name}`, 'gi').test(item.name)
                if (item.name.toString().toLowerCase().indexOf(name.toString().toLowerCase()) > -1) {
                    return item;
                }
            });
        }
    };
    /**
     * To set data in auto complete field , call this function
     * @param model - This is field name prefix like region , state, location , country, city etc..We have used this to create dynamic field for FilteredOptions
     * @param customData  - this is customDdata - a custom data which we have to set in the field. (Pass this param as null if you don't need of it)
     * @param control  - form control name
     * @param me  - scope of that component
     */
    Utility.prototype.setDataInComboField = function (model, customData, control, me) {
        var _this = this;
        var allData = [];
        if (customData && customData.length > -1) {
            allData = customData;
        }
        else {
            allData = this._sharedService[model + "List"]; // If no any custom data is passed get all data from service itself
        }
        me[model + "valueUpdated"] = allData;
        if (model && allData && allData.length > -1) {
            me[model + "FilteredOptions"] = control.valueChanges
                .startWith(null)
                .map(function (i) { return i && i === 'object' ? i.name : i; })
                .map(function (name) { return name ? _this.filterItems(allData, name) : allData.slice(); });
        }
    };
    /**
     * @param response - complete response object
     * @param customMessage  - custom message which you have to display, In case if you don't need of custom messge , pass it null
     * @param fn - call back function
     * @param isLoaderStart - loader is started or not, if value is true loader count would be removed
     */
    Utility.prototype.onSuccessCallback = function (response, customMessage, fn, isLoaderStart) {
        if (customMessage === void 0) { customMessage = null; }
        if (isLoaderStart === void 0) { isLoaderStart = true; }
        try {
            if (this._dialog.openDialogs.length > 1) {
                this._dialog.openDialogs.pop();
            }
            var code = response.responseCode.toUpperCase();
            if (code == 'S0001') {
                // Display alert box if custom message come in params
                if (customMessage) {
                    var OkMsgDialogRefModel = {
                        modelType: "SUCCESS",
                        msgTitle: 'Success',
                        msg: customMessage,
                        showDefaultBtn: true,
                        defaultBtnCaption: 'OK'
                    };
                    var OkMsgDialogRef = this._dialog.open(DialogConfirmComponentComponent, { data: OkMsgDialogRefModel })
                        .afterClosed().subscribe(function (result) {
                        if (fn) {
                            return fn(result);
                        }
                    });
                }
                else if (fn) {
                    return fn();
                }
            }
            else if (code == "E1009" || code == "E1166") {
                this._appGlobals.isInvalidToken = true;
                this.logoutUser(false);
            }
            else if (code == "E1018" || code == "E1007") {
                this._appGlobals.isInvalidToken = true;
                // Try logging them in again to fix their session
                this._appGlobals.logoutURL.next(this._appGlobals.baseURL.getValue() + 'externaluser/login');
                this.logoutUser(true);
            }
            else if (code == "E1055") {
                return;
            }
            else {
                var OkMsgDialogRefModel = {
                    modelType: "ERROR",
                    msgTitle: 'Oops!',
                    msg: '',
                    showDefaultBtn: true,
                    defaultBtnCaption: 'OK'
                };
                OkMsgDialogRefModel.msg =
                    this._appMessage.getItem[response.responseCode] == null
                        ? response.responseDescription ? response.responseDescription : this._appMessage.getItem['Common005'] //msg from api : something went wrong
                        : this._appMessage.getItem[response.responseCode]; // other message
                if (code == 'E0001') {
                    OkMsgDialogRefModel.msg = customMessage;
                }
                if (code == 'P0001') {
                    OkMsgDialogRefModel.msg = customMessage;
                    var OkMsgDialogRef_1 = this._dialog.open(DialogConfirmComponentComponent, { data: OkMsgDialogRefModel })
                        .afterClosed().subscribe(function (result) {
                        if (fn)
                            return fn(result);
                    });
                    return;
                }
                var OkMsgDialogRef = this._dialog.open(DialogConfirmComponentComponent, { data: OkMsgDialogRefModel });
            }
        }
        catch (Exception) {
        }
        finally {
            if (isLoaderStart == true) {
                this.removeLoaderCount();
            }
        }
    };
    // fn is callback : ? tell that it is optional parameter
    Utility.prototype.onErrorCallback = function (error, fn, isLoaderStart) {
        if (isLoaderStart === void 0) { isLoaderStart = true; }
        try {
            this._dialog.openDialogs.pop();
            // Check for Invalid token, so logout the user
            if (JSON.parse(error).responseCode == "E1007" || JSON.parse(error).responseCode == "E1018") {
                // Invalid token, so logout the user
                this.logoutUser();
            }
            else {
                var ErrorMsgDialogRefModel = {
                    modelType: "ERROR",
                    msgTitle: 'Oops!',
                    msg: JSON.parse(error).responseDescription,
                    showDefaultBtn: true,
                    defaultBtnCaption: 'OK'
                };
                var ErrorMsgDialogRef = this._dialog.open(DialogConfirmComponentComponent, {
                    data: ErrorMsgDialogRefModel
                });
            }
            // if (fn) {
            //     return fn();
            // }
        }
        catch (Exception) {
        }
        finally {
            if (isLoaderStart == true) {
                this.removeLoaderCount();
            }
            if (fn) {
                return fn();
            }
        }
    };
    /**
     * This function is called in case of Save  , Update
     * To format form Combo Fields data (get Ids from Object for combo fields)
     */
    Utility.prototype.manageFormDataforSave = function (formData) {
        if (formData) {
            var fields = Object.keys(formData);
            // Create specific data which are required to send "SAVE / UPDATE" request
            fields.forEach(function (element) {
                // Number(element) == NaN  -- added this condition because we have some form group with Name 0,1,2...(where we have added dynamic form groups) And we dont need to perform operation for them
                if (element && typeof formData[element] == "object" && !Number(element)) {
                    // If there are sub child in a child element
                    if (formData[element] && formData[element].length) {
                        var subchilds_1 = formData[element];
                        subchilds_1.forEach(function (subElement, index) {
                            if (typeof subElement == "object" && subElement.id)
                                subchilds_1[index] = subElement.id;
                        });
                    }
                    else if (formData[element] && formData[element].id) {
                        formData[element] = formData[element].id;
                    }
                }
            });
        }
        return formData;
    };
    /**
     * Based On city and state selected, Update timezone field Field name is consist that is timezone
     * @param value
     * @param me
     */
    Utility.prototype.setTimeZone = function (value, me) {
        var _this = this;
        if (me.formControl.stateId.value && me.formControl.cityId.value) {
            // timezone
            var id = me.formControl.cityId.value.id;
            if (id) {
                var param = "?outputType=" + Enum.TimeZone + "&id=" + id + "&inputType=" + Enum.City;
                this._sharedService.requestDataForCombo(param).subscribe(function (response) {
                    _this.onSuccessCallback(response, null, function () {
                        me.formControl.timezone.setValue(response.response.results[0].name);
                    });
                });
            }
            else {
                me.formControl.timezone.setValue('');
            }
        }
        else {
            me.formControl.timezone.setValue('');
        }
        return;
    };
    // Call this method to set format to 00:00/00:00:00
    Utility.prototype.setTimeFormat = function (time, ssShow) {
        if (ssShow === void 0) { ssShow = true; }
        var retVal = time;
        if (time != null && time != '') {
            var tempList = time.split(':');
            retVal = '';
            for (var count = 0; count < tempList.length; count++) {
                if (ssShow == true || count < 2) {
                    if (retVal != null && retVal.length > 0) {
                        retVal += ':';
                    }
                    retVal += (tempList[count] != null && tempList[count].toString().length < 2) ? ('0' + tempList[count].toString()) : tempList[count].toString();
                }
            }
        }
        return retVal;
    };
    /**
    * If we change value of combo field and that is not exists in auto fill data then disable update or save button
      If field is invalid then return "true" else return "false"
    */
    Utility.prototype.disableSaveUpdate = function (form) {
        var isDisable = true;
        if (form.disabled)
            return isDisable; // if form is disabled then return true
        var controls = form.controls;
        var fields = Object.keys(controls);
        for (var i = 0; i < fields.length; i++) {
            var field = fields[i];
            if (field.toLowerCase().substring(field.length - 2, field.length) == "id") {
                var control = controls[field];
                if (control && control.enabled && control.value) {
                    var id = control.value.id;
                    if (!id) {
                        isDisable = true;
                        return isDisable;
                    }
                    else {
                        isDisable = false;
                    }
                }
            }
        }
        return isDisable;
    };
    // Show the Messages (Success/Error/Validation)
    Utility.prototype.showDialogMsg = function (message, msgType, msgTitle, showDefaultBtn, defaultBtnCaption) {
        if (msgType === void 0) { msgType = "ERROR"; }
        if (msgTitle === void 0) { msgTitle = this._appMessage.getItem['Common010']; }
        if (showDefaultBtn === void 0) { showDefaultBtn = true; }
        if (defaultBtnCaption === void 0) { defaultBtnCaption = this._appMessage.getItem['Common011']; }
        var msgDialogRefModel = {
            modelType: msgType,
            msgTitle: msgTitle,
            msg: message,
            showDefaultBtn: showDefaultBtn,
            defaultBtnCaption: defaultBtnCaption
        };
        var msgDialogRef = this._dialog.open(DialogConfirmComponentComponent, {
            data: msgDialogRefModel
        });
    };
    /**
     * This function is required to set Name value in autocomplete combo fields
     * we are doing this because for Cascading combo and for save / update we need Id and for display we need Name property
     * @param option - This parameter contains object like {name: 'test', id: 1}
     */
    Utility.prototype.displayFn = function (option) {
        if (option && option.hasOwnProperty('name')) {
            return option.name;
        }
        if (option && option.hasOwnProperty('showStr')) {
            return option.showStr;
        }
    };
    /**
     *
     * @param userId - admin user id for which you have to do retire
     * @param roleType - Role type is global admin , site admin or regional admin - we have to display message based on this
     * @param activate -  pass true if we have to activate User else pass false to retire user
     * @param fn - call bacnk function so that we can handle our logic after successfully retired
     */
    Utility.prototype.doRetireActiveAdmin = function (userId, roleType, activate, fn) {
        var _this = this;
        var param = { "identityId": userId, "identityType": Enum.IdentityType_Admin, "status": activate ? Enum.StatusActive : Enum.StatusRetire };
        var successMsg = activate ? this._appMessage.getItem['UMsg00081'] : this._appMessage.getItem['UMsg00032'];
        var role;
        if (roleType == Enum.RoleTypeRegionalAdmin) {
            role = "Regional Administrator";
        }
        else if (roleType == Enum.RoleTypeGlobalAdmin) {
            role = "Global Administrator";
        }
        else {
            role = "Site Administrator";
        }
        successMsg = role + " " + successMsg;
        var confirmDialogMsgModel = {
            modelType: "CONFIRMATION",
            msgTitle: this._appMessage.getItem['Common007'],
            msg: activate ? this._appMessage.getItem['UMsg00082'] : this._appMessage.getItem['UMsg00049'],
            isConfirmBox: true,
            confirmBtnCaption: this._appMessage.getItem['Common014'],
            cancelBtnCaption: this._appMessage.getItem['Common015'],
        };
        var confirmDialogMsgRef = this._dialog.open(DialogConfirmComponentComponent, {
            data: confirmDialogMsgModel
        });
        confirmDialogMsgRef.afterClosed().subscribe(function (result) {
            if (result == "1") {
                _this.addLoaderCount();
                _this._sharedService.retireActivateAdmin(param).subscribe(function (data) {
                    _this.onSuccessCallback(data, successMsg, function () {
                        return fn();
                    });
                }, function (error) {
                    _this.onErrorCallback(error);
                });
            }
        });
    };
    Utility.prototype.findByMatchingProperties = function (set, properties) {
        return set.filter(function (entry) {
            return Object.keys(properties).every(function (key) {
                return entry[key] === properties[key];
            });
        });
    };
    /**
     * By this function we are manage Combo fields data which we have to set on form
     * In Get request we are getting Ids of combo fields like region, country etc.. so by this function we will get there name also
     * @param data - Response which coming from request
     */
    Utility.prototype.manageFormComboData = function (data, customPropertyMapList) {
        var _this = this;
        if (data && data.id) {
            // For all combo fields fetch {Name and Id} from saved data based on coming Id and Update response
            var fields = Object.keys(data);
            var _loop_1 = function () {
                var field = fields[i];
                if (customPropertyMapList && customPropertyMapList.length > 0) {
                    var tempCustomPropertyMap = customPropertyMapList.filter(function (item) { return item.field == field; })[0];
                    if (tempCustomPropertyMap) {
                        data[tempCustomPropertyMap.map] = data[field];
                        field = tempCustomPropertyMap.map;
                    }
                }
                if (field.toLowerCase().substring(field.length - 2, field.length) == "id" && data[field]) {
                    var prefix_1 = field.substring(0, field.length - 2);
                    if (prefix_1) {
                        if (typeof data[field] == 'object' && data[field].length > 0) {
                            if (prefix_1.toLowerCase() == 'approvercountry') {
                                prefix_1 = 'country';
                            }
                            var subchilds_2 = data[field];
                            subchilds_2.forEach(function (subElement, index) {
                                var obj = _this.getRecordById(prefix_1, subElement);
                                if (obj)
                                    subchilds_2[index] = obj;
                            });
                        }
                        else {
                            var obj = this_1.getRecordById(prefix_1, data[field]);
                            if (obj) {
                                data[field] = obj;
                            }
                        }
                    }
                }
            };
            var this_1 = this;
            for (var i = 0; i < fields.length; i++) {
                _loop_1();
            }
        }
        return data;
    };
    /**
     *
     * @param fn - If click on confirm then this call back function executes
     * @param cancelFn  -- If click on cancel then this call back function executes
     */
    Utility.prototype.showUnsavedChangesConfirmBox = function (fn, cancelFn) {
        var _this = this;
        var confirmDialogMsgModel = {
            modelType: "CONFIRMATION",
            msgTitle: 'Are you sure?',
            msg: 'You have not saved your changes! You will lose any unsaved data. Do you wish to continue?',
            isConfirmBox: true,
            confirmBtnCaption: 'Confirm',
            cancelBtnCaption: 'Cancel'
        };
        var confirmDialogMsgRef = this._dialog.open(DialogConfirmComponentComponent, {
            data: confirmDialogMsgModel
        });
        confirmDialogMsgRef.afterClosed().subscribe(function (result) {
            if (result == "1") {
                _this.clearTxnStatus();
                return fn();
            }
            else if (cancelFn) {
                return cancelFn();
            }
        });
    };
    // To generate the showtext of Operational Hours
    Utility.prototype.getOperationalHours = function (opHoursObj, cDate) {
        if (cDate === void 0) { cDate = null; }
        var retVal = "";
        if (opHoursObj && opHoursObj.length) {
            for (var hCount = 0; hCount < opHoursObj.length; hCount++) {
                if (cDate == null || cDate == "") {
                    if (retVal.length > 0) {
                        retVal += ', ';
                    }
                    retVal += this.days[opHoursObj[hCount].weekDay - 1] + ": " + opHoursObj[hCount].startTime + "-" + opHoursObj[hCount].endTime;
                }
                else if (new Date(cDate).getUTCDay() == opHoursObj[hCount].weekDay - 1) {
                    retVal = opHoursObj[hCount].startTime + "-" + opHoursObj[hCount].endTime;
                }
            }
        }
        return retVal;
    };
    /**
     * Function check for duplicates names in admin data, If there are two same names on that case we have to display unique names
     * @param list - collection of data comes from api
     */
    Utility.prototype.checkDuplicateRecord = function (list) {
        var distintRecords = [];
        distintRecords.push(list[0]);
        // check for unique show string
        for (var i = 1; i < list.length; i++) {
            if (list[i].hasOwnProperty('showStr')) {
                if ((list[i].showStr).toLowerCase() !== (list[i - 1].showStr).toLowerCase()) {
                    distintRecords.push(list[i]);
                }
            }
            else if (list[i].hasOwnProperty('fullName')) {
                if ((list[i].fullName).toLowerCase() !== (list[i - 1].fullName).toLowerCase()) {
                    distintRecords.push(list[i]);
                }
            }
        }
        return distintRecords;
    };
    /**
     * Function create url and download the file
     * @param data - response body
     * @param fileName - name of the file to download
     */
    Utility.prototype.downloadFileFromBlob = function (data, fileName) {
        //for chrome of ios
        if (navigator.userAgent.match('CriOS')) {
            var fileData = [data];
            var reader = new FileReader();
            var blob = new Blob(fileData, { type: data.type });
            reader.onload = function (e) {
                window.location.href = reader.result;
            };
            reader.readAsDataURL(blob);
        }
        else if (window.navigator.msSaveOrOpenBlob) {
            var fileData = [data];
            var blobObject = new Blob(fileData);
            window.navigator.msSaveBlob(blobObject, fileName);
        }
        else {
            var a = document.createElement("a");
            document.body.appendChild(a);
            var url = window.URL.createObjectURL(data);
            a.href = url;
            a.download = fileName; //name of the file to download
            a.click();
            window.URL.revokeObjectURL(url);
        }
    };
    /**
     * Function find object by given attribute value, remove it from the list and return the updated list
     * @param arr - array/list
     * @param attr - name of the attribute to compare
     * @param value - value of the attribute to compare
     */
    Utility.prototype.removeByAttr = function (arr, attr, value) {
        var i = arr.length;
        while (i--) {
            if (arr[i]
                && arr[i].hasOwnProperty(attr)
                && (arguments.length > 1 && arr[i][attr] === value)) {
                arr.splice(i, 1);
            }
        }
        return arr;
    };
    /**
     * Function find object by given attribute value, update it in the list and return the updated list
     * @param arr - array/list
     * @param attr - name of the attribute to compare
     * @param value - value of the attribute to compare
     * @param updatePropName - attribute name to update
     * @param updatePropVal - attribute value to update
     */
    Utility.prototype.updateByAttr = function (arr, attr, value, updatePropName, updatePropVal) {
        var i = arr.length;
        while (i--) {
            if (arr[i]
                && arr[i].hasOwnProperty(attr)
                && (arguments.length > 1 && arr[i][attr] === value)) {
                arr[i][updatePropName] = updatePropVal;
            }
        }
        return arr;
    };
    Utility.prototype.isNull = function (val) {
        if (val == undefined || val == null || val == '' || val == 0 || val == [])
            return true;
        return false;
    };
    /**
     * Log out function when click on log out button
     * If you don't want to redirect on other URL then pass param : redirect = false
     */
    Utility.prototype.logoutUser = function (redirect, eCode) {
        if (redirect === void 0) { redirect = true; }
        if (eCode === void 0) { eCode = null; }
        localStorage.clear();
        this._appGlobals.accessToken.next(null);
        this._appGlobals.isUserLoggedIn.next(false);
        var logoutURL = this._appGlobals.logoutURL.getValue();
        this._appGlobals.userInfo.next(null);
        if (this._appGlobals.isInternalUser) {
            this._appGlobals.routeWithID = true; // make this property true so that routes only activate when comes from internal User logout click only
            this._router.navigate(['Logout']);
        }
        else {
            if (redirect && logoutURL) {
                window.location.href = logoutURL;
            }
            else {
                this.setUserLoggedInStatus(false);
                if (eCode != null && eCode != "") {
                    this._router.navigate(['**', { eid: eCode }]);
                }
                else {
                    this._router.navigate(['**']);
                }
            }
        }
    };
    /**
     * For auto complete fields if entered value is not selected from dropdown then disable search button
     * @param form -  instance of Form
     * @param otherFields  - pass array of fields which are not auto complete field (Like text fields)
     * @param isDefaultEnable - pass true to enable search by default and false to conditional enable search button
     */
    Utility.prototype.searchDisable = function (form, otherFields, isDefaultEnable) {
        if (otherFields === void 0) { otherFields = []; }
        var isSearchDisable = true;
        var keys = Object.keys(form);
        var values = this.objValues(form);
        for (var i = 0; i < values.length; i++) {
            var value = values[i];
            if (value) {
                if ((value.id || otherFields.indexOf(keys[i]) > -1)) {
                    isSearchDisable = false;
                }
                else {
                    isSearchDisable = true;
                    break;
                }
            }
            else if (isDefaultEnable) {
                isSearchDisable = false;
            }
        }
        return isSearchDisable;
    };
    //hide notification dropdown for candidate when clicked from outside
    Utility.prototype.toggle_class = function () {
        if (this.toggle_my_Class.toLowerCase() == "active") {
            this.toggle_my_Class = 'inactive';
        }
    };
    /**
      * used to farmat input text
      * @param input - input value passed that needs to be formatted
      * @param breakPoint - Number at which separator is appended
      * @param sep - separator that is appended
      */
    Utility.prototype.textFormat = function (input, breakPoint, sep) {
        input = input.replace(/-/g, "");
        var output = "";
        var idx = 0;
        for (var i = 0; idx < input.length; i++) {
            output += input.substr(idx, breakPoint);
            if (idx + breakPoint < input.length)
                output += sep;
            idx += breakPoint;
        }
        output += input.substr(idx);
        return output;
    };
    Utility.prototype.getCandidateEmail = function () {
        if (this.isAdminAsCandidate()) {
            return this._appGlobals.candidateEmail;
        }
        return this._appGlobals.userInfo.getValue().email;
    };
    Utility.prototype.getUserRole = function () {
        return this._appGlobals.userInfo.getValue().userRole;
    };
    Utility.prototype.isAdminAsCandidate = function () {
        return Boolean(this._appGlobals.userId);
    };
    Utility.prototype.adminBecomeCandidate = function (id, email) {
        this._appGlobals.userId = id;
        this._appGlobals.candidateEmail = email;
    };
    Utility.prototype.adminUnbecomeCandidate = function () {
        this._appGlobals.userId = 0;
        this._appGlobals.candidateEmail = null;
    };
    Utility.prototype.effectiveExamStatusIs = function (exam, status) {
        var statusMapping = {
            COMPLETED: "COMPLETED",
            EXAMSEXPIRED: "EXAMSEXPIRED",
            EXAMSTOSCHEDULE: "EXAMSTOSCHEDULE",
            NOSHOW: "COMPLETED",
            RESCHEDULED: "SCHEDULED",
            SCHEDULED: "SCHEDULED",
        };
        return statusMapping[exam.status.toUpperCase()] == status.toUpperCase();
    };
    Utility.prototype.effectiveExamStatusIsIn = function (exam, statuses) {
        for (var _i = 0, statuses_1 = statuses; _i < statuses_1.length; _i++) {
            var status_1 = statuses_1[_i];
            if (this.effectiveExamStatusIs(exam, status_1)) {
                return true;
            }
        }
        return false;
    };
    Utility.prototype.usesVirtualLocation = function (exam) {
        return exam && exam.usesVirtualLocation;
    };
    //
    // Custom Exam Style Classes
    //
    Utility.prototype.examModelRow1CSSClass = function (exam) {
        return (exam && exam.examType || 'ue').toLowerCase() + 'ExamModelRow1';
    };
    Utility.prototype.examScheduleDetailListSecCSSClass = function (exam) {
        return (exam && exam.examType || 'ue').toLowerCase() + 'ExamScheduleDetailListSec';
    };
    Utility.prototype.examBackgroundCSSClass = function (exam) {
        return (exam && exam.examType || 'ue').toLowerCase() + 'ExamBackground';
    };
    Utility.prototype.examNameCSSClass = function (exam) {
        return (exam && exam.examType || 'ue').toLowerCase() + 'ExamName';
    };
    Utility.prototype.examBorderBottomCSSClass = function (exam) {
        return (exam && exam.examType || 'ue').toLowerCase() + 'ExamBorderBottom';
    };
    //
    // End Custom Exam Style Classes
    //
    Utility.prototype.getExamTypeDisplay = function (examType) {
        var matchingExamType = examTypeOptions.find(function (examTypeOption) { return examTypeOption.examType == examType; });
        return null === matchingExamType ? "" : matchingExamType.name;
    };
    return Utility;
}());
export { Utility };



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/Services/utility.ts.pre-build-optimizer.js